/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSeeding = createReactComponent("seeding", "IconSeeding", [
  ["path", { d: "M12 10a6 6 0 0 0 -6 -6h-3v2a6 6 0 0 0 6 6h3", key: "svg-0" }],
  ["path", { d: "M12 14a6 6 0 0 1 6 -6h3v1a6 6 0 0 1 -6 6h-3", key: "svg-1" }],
  ["path", { d: "M12 20l0 -10", key: "svg-2" }]
]);

export { IconSeeding as default };
//# sourceMappingURL=IconSeeding.js.map
